import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 20px;
  background-color: white;
  display: none;
  border-radius: 8px;
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: unset;
  }
`;

export const ClientInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ClientAddressWrapper = styled.div`
  font-family: "Mulish";
  color: ${({ theme }) => theme.palette.primary.blue900};
`;

export const ClientAddress = styled.h6`
  width: 55%;
  font-weight: 700;
  font-size: ${14 / 16}rem;
`;

export const ClientName = styled.p`
  font-weight: 600;
  font-size: ${12 / 16}rem;
`;
export const ClientPhotoCityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ClientPhotoWrapper = styled.div`
  border-radius: 50%;
  overflow: hidden;
  width: 42px;
  height: 42px;
`;

export const ClientImage = styled.img`
  width: 100%;
`;

export const ClientCity = styled.p`
  margin-top: 24px;
  color: ${({ theme }) => theme.palette.greyscale.grey200};
  font-family: "Mulish";
  font-weight: 400;
  font-size: ${12 / 16}rem;
  white-space: nowrap;
`;

export const SignedContract = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.blue50};
  color: ${({ theme }) => theme.palette.primary.blue500};
  font-family: "Mulish";
  font-weight: 700;
  font-size: ${12 / 16}rem;
  padding: 12px;
  text-align: center;
  margin-top: 24px;
`;
